export default __webpack_public_path__ + "static/media/hht1_ep02_timeline_06.671b67b5.png";